# Initialise foundation core.

    (($, Drupal) ->
        Drupal.behaviors.foundationInit =
            attach: (context) ->
                html = $('html', context).once 'foundation-init'
                if html.length
                    html.foundation()
    )(jQuery, Drupal)
